<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Locker Information</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCloseModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid fixed>
    <ion-row *ngIf="locker">
      <ion-col size="12">
        <ion-card>
          <ion-card-header>
            <ion-card-subtitle>{{ locker.Location }}</ion-card-subtitle>
            <ion-card-title
              >{{ locker.BuildingName }}
              <ion-badge color="warning"
                >Printing is unavailable</ion-badge
              ></ion-card-title
            >
          </ion-card-header>
          <ion-card-content>
            <ion-row>
              <ion-col size="12">{{locker.AreaName}}</ion-col>
              <ion-col size="12">{{locker.AreaDescr}}</ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="6" class="ion-text-right">Sale Window</ion-col>
              <ion-col size="6">{{locker.SemTitle}}</ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="6" class="ion-text-right">Locker Number</ion-col>
              <ion-col size="6">{{locker.LockerNum}}</ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="6" class="ion-text-right">Rental Cost</ion-col>
              <ion-col size="6"><b>{{ locker.amount | currency }}</b></ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="6" class="ion-text-right">Condition</ion-col>
              <ion-col size="6">{{conditions[locker.Condition]}}</ion-col>
            </ion-row>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
